<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../components/isaMain/Contact.vue'
import PositionSummary from '../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../components/AssessmentIsa/BasicReq.vue'
import Faq from '../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'GET HIRED AS A FRONT END ENGINEER (REMOTE)',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Take the assessment curated by Upskill and get a chance to work at DocSpace, as a front end engineer.',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/1f0937d9-b93c-45b3-84f5-b02352cdaa49?public=true&job=Docspace-Frontendengineer',
        landingImage:
          'https://upskill-frontend.s3.ap-southeast-1.amazonaws.com/HrApp+Assets/Frontend+Developer.png',
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../assets/AssementLanding/Company_Logo/rsz_61d349a2268b8afa5cfcc0eb_logo___primary.png'),
        info:
          'DocSpace is a practice operations platform that helps clinicians start, manage, and grow an independent practice. DocSpace provides everything clinicians need to form a tech-enabled business, from automating business entities, licensing, credentialing, and banking, to customizing practice management workflows with collaborative clinical care team environments that are end-to-end HIPAA-compliant.',
        designation: '',

        bgColor: '#333333',
        txtColor: 'white',
      },
      programData: {
        headingInfo:
          'Senior Network Administrator Assessment consists of approximately 15 MCQs. You are required to pass the assessment test with a minimum of 60% of the total score. Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment. So, don’t miss this opportunity as the time is limited!',
        startDate: '11th April',
        cost: 'Free',
        deadline: '22nd April',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },

      basicRequirement: {
        mainContent: [
          '3+ years experience developing using NextJS, React applications Proficiency in JavaScript, Typescript.',
          'Ability to work independently under minimal supervision',
          'Deep experience building websites as part of a technical team Experience with e-commerce and/or payments',
          'Experience shipping third-party JavaScript libraries or web SDKs Knowledge and work experience in micro frontends will be an added bonus Basic knowledge of Dev-Ops, cloud deployment will be an added bonus',
        ],
        bgColor: '#333333',
      },

      outlineColor: {
        color: '#33333',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content: 'Yes, 3 years experience as a Frontend Developer \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 9 out of 15',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at DocSpace?\n',
          content:
            'No, the top 5 students will get a chance to interview at DocSpace and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' 200,000 - 280,000 BDT/Month \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
